import { useCallback, useEffect, useState } from "react";

import api from "../../../../api/api";

const useGetTopUp = () => {
  const [data, setData] = useState(null);
  const [loading, _setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTopUp = useCallback(async () => {
    try {
      const response = await api.get("/api/firmsetting-page/top-up/");
      setData(response.data);
    } catch (error) {
      setError(error);
    }
  }, []);

  useEffect(() => {
    fetchTopUp();
  }, [fetchTopUp]);

  return { data, loading, error, refetch: fetchTopUp };
};

export default useGetTopUp;
